module.exports = __webpack_public_path__ + "static/assets/1c78a936bf640a0c11b21af1330d15df.png";